/* eslint-disable no-unused-vars */
import { onActivated, onDeactivated, onUnmounted, onMounted, computed, ref } from "vue";
import addMissingSelectValue from "@/utils/inputs/add_missing_select_value";
import { clone } from "lodash-es";
import { sortBy } from "lodash-es";
/**
 * Factory to create base helper functions for masterdata
 * @param getData Function that returns array
 * @returns helper functions
 *
 * masterdataEntities - returns computed getData returned value
 *
 * activeEntities - returns masterdata entities that have status == 'active'
 *
 * getFromMasterdata(id: string, key: string = null) - returns masterdata entity by id
 *
 * addMissingSelectValue(value, props) - wrapper for addMissingSelectValue
 */
export function buildMasterdataHelper(getData) {
    // Ref hates getting T
    const masterdataEntities = ref(sortByRank(getData()));
    function getAndSorted() {
        masterdataEntities.value = sortByRank(getData());
    }
    onActivated(() => {
        window.addEventListener("manualApolloRefresh", getAndSorted);
    });
    onDeactivated(() => {
        window.removeEventListener("manualApolloRefresh", getAndSorted);
    });
    onMounted(() => {
        window.addEventListener("manualApolloRefresh", getAndSorted);
    });
    onUnmounted(() => {
        window.removeEventListener("manualApolloRefresh", getAndSorted);
    });
    const activeEntities = computed(() => {
        return returnActiveItems(masterdataEntities.value);
    });
    return {
        masterdataEntities,
        activeEntities,
        getFromMasterdata: function (id, key = null) {
            return getFromMasterdata(masterdataEntities.value, id, key);
        },
        addMissingSelectValue: (value, props) => {
            return addMissingSelectValueAdHoc({
                value,
                props,
                activeEntities,
                masterdataEntities
            });
        }
    };
}
/**
 * Sorts array items by rank
 * @param items array of items
 * @returns sorted items by rank
 */
export function sortByRank(items) {
    return sortBy(clone(items), "rank");
}
/**
 * Filter items by field status with value 'active'
 * @param items array of items
 * @returns items that have status value 'active' or if x.status is falsy returns all
 */
export function returnActiveItems(items) {
    return items.filter(x => (x.status ? x.status == "active" : true)); // turns out, Country/VatRate doesn't have status field 😭
}
/**
 *
 * @param {array} masterdataEntities array of masterdata entitites
 * @param {string} id id that references to masterdata tiem
 * @param {string} key optional. return field's value instead of masterdata entity object
 * @returns masterdata entity object or its field's value when given key prop
 */
export function getFromMasterdata(masterdataEntities, id, key = null) {
    const data = masterdataEntities.find(x => x.id == id);
    return data && key ? data[key] : data;
}
export function addMissingSelectValueAdHoc({ value, props, activeEntities, masterdataEntities }) {
    props = clone(props);
    const items = props.customItems && Array.isArray(props.customItems)
        ? props.customItems
        : activeEntities.value;
    delete props.customItems; // deleteing it affected testing if customItems is present
    return addMissingSelectValue(value, items, {
        rawItems: masterdataEntities.value,
        keyValue: "id",
        ...props
    });
}
